import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { useOnClickOutside } from '@zocdoc-frontend-common/utils-react';
import { blue100, slate30, white } from '@zocdoc-mezzanine/foundations-colors';
import { SpecialtyTab } from './SpecialtyTab';

/**
 * A popup table with links to Listing Pages for top specialties in the top locations
 *  This is being added to improve SEO rankings for Google's new EAT
 * @param {Array} cities -- List of Cities with names and urls
 * @param {Array} specialties -- List of Specialties with names and urls
 * @param {Boolean} isVisible -- Whether to show Popup
 * @param {function} handleClickOutside -- Callback to handle clicks outside popup
 * @param {string} hostOverride
 * @returns {JSX.Element}
 */
export const Popup = ({
    cities,
    specialties,
    isVisible,
    handleClickOutside,
    hostOverride = '',
}) => {
    const [activeSpecialtyTab, setActiveSpecialtyTab] = useState(0);

    const wrapperRef = useRef(null);
    useOnClickOutside(wrapperRef, handleClickOutside);

    return (
        <PopupContainer
            ref={wrapperRef}
            data-test="popup-outer-container"
            $visible={isVisible}
        >
            <UpArrow />
            <TopListingPagesContainer data-test="top-listing-pages-popup">
                <TabsContainer>
                    {specialties.map((specialty, idx) => (
                        <SpecialtyTab
                            key={specialty.name}
                            specialty={specialty}
                            cities={cities}
                            isActive={activeSpecialtyTab === idx}
                            setActive={() => setActiveSpecialtyTab(idx)}
                            hostOverride={hostOverride}
                        />
                    ))}
                </TabsContainer>
            </TopListingPagesContainer>
        </PopupContainer>
    );
};

const PopupContainer = styled.div`
    display: none;
    z-index: 10;
    position: relative;
    top: 28px;
    left: 75px;

    ${breakpoint.medium} {
        display: ${(p) => (p.$visible ? 'block' : 'none')};
    }
`;
const TopListingPagesContainer = styled.div`
    flex-direction: column;
    background-color: ${white};
    padding: 32px 10px 0 25px;
    color: ${blue100};
    border: 1px ${slate30} solid;
    border-top: none;

    position: absolute;
    right: -450px;
    height: 356px;
    min-width: 1024px;
    max-width: 100%;
`;

const TabsContainer = styled.div`
    position: relative;
`;

const UpArrow = styled.div`
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-right: 30px solid transparent;
    border-bottom: 30px solid white;
`;
